export const POSITIONS = [
  "OFFICER",
  "DETECTIVE",
  "COMMANDER",
  "CORPORAL",
  "MAJOR",
  "SERGEANT",
  "LIEUTENANT",
  "CAPTAIN",
  "DEPUTY_CHIEF",
  "CHIEF",
  "ADMIN",
];

export type ColumnKey =
  | "firstName"
  | "lastName"
  | "rank"
  | "badgeNumber"
  | "department"
  | "email"
  | "role"
  | "status"
  | "rmsUserId"
  | "bodycamUserId"
  | "actions";

export interface ColumnDef {
  key: ColumnKey;
  label: string;
  tooltip?: string;
  width: number;
  align?: "left" | "right" | "center";
  noEllipsis?: boolean;
}

export const USER_COLUMNS: ColumnDef[] = [
  { key: "firstName", label: "First", tooltip: "First Name", width: 120 },
  { key: "lastName", label: "Last", tooltip: "Last Name", width: 100 },
  { key: "rank", label: "Rank", tooltip: "Rank", width: 85 },
  { key: "badgeNumber", label: "Badge", tooltip: "Badge Number", width: 100 },
  { key: "department", label: "Dept.", tooltip: "Department", width: 85 },
  { key: "email", label: "Email", width: 190 },
  { key: "role", label: "Role", tooltip: "KARDA access role", width: 130 },
  { key: "status", label: "Status", width: 139, align: "center" },
  {
    key: "actions",
    label: "Actions",
    width: 100,
    align: "center",
    noEllipsis: true,
  },
];

export const ROW_HEIGHT = 40;
export const DEFAULT_ROWS_PER_PAGE = 10;
export const CSV_PREVIEW_DEFAULT_PAGINATION = 10;
